import { Image, PictureAsPdf } from "@mui/icons-material";
import { alpha, Box, Chip } from "@mui/material";
import { useEffect, useMemo } from "react";
import { theme } from "src/assets/theme";

interface Props {
  file: File;
}

const FilePreview = ({ file }: Props) => {
  const filePreviewUrl = useMemo(
    () =>
      file && file.type.startsWith("image/") ? URL.createObjectURL(file) : null,
    [file],
  );

  useEffect(() => {
    return () => {
      if (filePreviewUrl) URL.revokeObjectURL(filePreviewUrl);
    };
  }, []);

  return filePreviewUrl ? (
    <Box
      component="img"
      src={filePreviewUrl}
      alt={file.name}
      sx={{
        maxWidth: "100%",
        maxHeight: 150,
        borderRadius: "10px",
        objectFit: "cover",
        border: `1px solid ${alpha(theme.palette.primary.main, 0.3)}`,
      }}
    />
  ) : (
    <Chip
      label={file.name}
      icon={file.type === "application/pdf" ? <PictureAsPdf /> : <Image />}
    />
  );
};

export default FilePreview;
